<template>
  <div class="zhuaqiu-query-page">
    <img class="top-bg" src="/static/images/zq/bg2.png" />
    <div class="content-container">
      <img class="logo" src="/static/images/zq/logo.png" />
      <img class="system" src="/static/images/zq/system.png" />
      <img class="pitou2" src="/static/images/zq/pitou2.png" />
      <div class="input-section">
        <img class="input-container" src="/static/images/zq/input-container.png" />
        <div class="input-wrapper">
          <input type="text" class="code-input" v-model="code" placeholder="请输入16位防伪码或扫码查询" />
          <img class="scan-btn" src="/static/images/zq/scan.png" @click="handleScan" />
        </div>
      </div>
      <img class="query-btn" src="/static/images/zq/query.png" @click="handleQuery" />
      <div class="bottom-bar"></div>
      <img class="bottom2" src="/static/images/zq/bottom2.png" />
    </div>
    <!-- Query页面内容 -->
  </div>
</template>

<style scoped>
.zhuaqiu-query-page {
  width: 100vw;
  min-height: 100vh;
  background-image: url('/static/images/zq/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.top-bg {
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.content-container {
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.logo {
  width: 16vw;
  height: auto;
  margin-top: 4vh;
}

.system {
  width: 85vw;
  height: auto;
  margin-top: 4vh;
}

.pitou2 {
  width: 45vw;
  height: auto;
  margin-top: 4vh;
}

.input-section {
  position: relative;
  width: 70vw;
  margin-top: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-container {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;
}

.input-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 2;
}

.code-input {
  width: 77%;
  height: 80%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 3.6vw;
  padding: 0;
  margin: 0;
  margin-left: 5%;
}

.scan-btn {
  width: 8%;
  height: auto;
  cursor: pointer;
  margin-left: 5%;
}

.query-btn {
  width: 73vw;
  height: auto;
  margin-top: 2vh;
  cursor: pointer;
}

.bottom-bar {
  width: 100vw;
  height: 5vh;
  background-color: rgb(198, 0, 22);
  position: fixed;
  bottom: 0;
  left: 0;
}

.bottom2 {
  width: 50vw;
  height: auto;
  position: fixed;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

@media screen and (max-height: 600px) {
  .logo {
    width: 12vw;
  }

  .system {
    width: 75vw;
  }

  .pitou2 {
    width: 40vw;
  }

  .input-section {
    width: 65vw;
  }

  .query-btn {
    width: 65vw;
  }
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'ZhuaQiuQuery',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138495222640' : '138603493800',
      appId: process.env.ENV_NUM === '1' ? 'wx22242a811779ec8c' : 'wxbc22565b3e7a59fd',
      code: ''
    }
  },
  methods: {
    handleScan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.code = scanQRCode
          this.$router.push({
            path: '/zhuaqiu/result',
            query: {
              eno: this.eno,
              c: this.code
            }
          });
        }
      });
    },
    handleQuery() {
      if (this.code.length !== 16) {
        alert('请输入16位防伪码或扫码查询');
        return;
      }
      this.$router.push({
        path: '/zhuaqiu/result',
        query: {
          eno: this.eno,
          c: this.code
        }
      });
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    this.getWxJs();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuaQiu/Query.vue